import Vehicle from '@/models/Vehicle';

/**
 * VehicleRepository - VuexORM queries for vehicles
 */
export default class VehicleRepository {
    /**
     * Get all vehicles
     */
    public static getAll(): Vehicle[] {
        return Vehicle.query().all();
    }

    /**
     * Get a single vehicle by ID
     */
    public static getById(id: string): Vehicle | null {
        if (!id) {
            return null;
        }
        return Vehicle.query().whereId(id).first();
    }

    /**
     * Get vehicles by driver
     */
    public static getByDriver(driver: string): Vehicle[] {
        return Vehicle.query().where('driver', driver).get();
    }

    /**
     * Get vehicles by type
     */
    public static getByType(type: string): Vehicle[] {
        return Vehicle.query().where('type', type).get();
    }

    /**
     * Get vehicles by registration
     */
    public static getByRegistration(registration: string): Vehicle | null {
        return Vehicle.query().where('registration', registration).first();
    }
}
